import * as types from './types';

export function searchRoles(payload, cb) {
  return {
    type: types.SEARCH_ROLES,
    payload,
    cb,
  };
}

export function searchRolesSuccess(payload) {
  return {
    type: types.SEARCH_ROLES_SUCCESS,
    payload,
  };
}

export function searchRolesFailure(payload) {
  return {
    type: types.SEARCH_ROLES_FAILURE,
    payload,
  };
}
export function setParamsRoles(payload) {
  return {
    type: types.SET_PARAMS_ROLES,
    payload,
  };
}

export function createRole(payload, cb) {
  return {
    type: types.CREATE_ROLE,
    payload,
    cb,
  };
}
export function getRoleById(payload, cb) {
  return {
    type: types.GET_ROLES_BY_ID,
    payload,
    cb,
  };
}

export function getRoleByIdSuccess(payload) {
  return {
    type: types.GET_ROLES_BY_ID_SUCCESS,
    payload,
  };
}

export function getRoleByIdFailure(payload) {
  return {
    type: types.GET_ROLES_BY_ID_FAILURE,
    payload,
  };
}

export function modifyRole(payload, cb) {
  return {
    type: types.MODIFY_ROLE,
    payload,
    cb,
  };
}

export function searchAllRoles(payload, cb) {
  return {
    type: types.SEARCH_ALL_ROLES,
    payload,
    cb,
  };
}
export function searchRoleGroups(payload, cb) {
  return {
    type: types.SEARCH_ROLE_GROUPS,
    payload,
    cb,
  };
}

export function searchRoleGroupsSuccess(payload) {
  return {
    type: types.SEARCH_ROLE_GROUPS_SUCCESS,
    payload,
  };
}

export function searchRoleGroupsFailure(payload) {
  return {
    type: types.SEARCH_ROLE_GROUPS_FAILURE,
    payload,
  };
}
export function setParamsRoleGroups(payload) {
  return {
    type: types.SET_PARAMS_ROLE_GROUPS,
    payload,
  };
}

export function getRoleGroupById(payload, cb) {
  return {
    type: types.GET_ROLE_GROUP_BY_ID,
    payload,
    cb,
  };
}

export function modifyRoleGroup(payload, cb) {
  return {
    type: types.MODIFY_ROLE_GROUP,
    payload,
    cb,
  };
}

export function searchAllRoleGroups(cb) {
  return {
    type: types.SEARCH_ALL_ROLE_GROUPS,
    cb,
  };
}

export function createRoleGroup(payload, cb) {
  return {
    type: types.CREATE_ROLE_GROUP,
    payload,
    cb,
  };
}
// <--  Users Management -->
// Search Users request
export function searchUsers(payload, cb) {
  return {
    type: types.SEARCH_USERS,
    payload,
    cb,
  };
}

export function searchUserSuccess(payload) {
  return {
    type: types.SEARCH_USERS_SUCCESS,
    payload,
  };
}

export function searchUsersFailure(payload) {
  return {
    type: types.SEARCH_USERS_FAILURE,
    payload,
  };
}

export function setParamsListUsers(payload) {
  return {
    type: types.SET_PARAMS_LIST_USERS,
    payload,
  };
}

// Detail User
export function getUserById(payload, cb) {
  return {
    type: types.GET_USER_BY_ID,
    payload,
    cb,
  };
}

export function getUserByIdSuccess(payload) {
  return {
    type: types.GET_USER_BY_ID_SUCCESS,
    payload,
  };
}

export function modifyUser(payload, cb) {
  return {
    type: types.MODIFY_USER,
    payload,
    cb,
  };
}

export function createUser(payload, cb) {
  return {
    type: types.CREATE_USER,
    payload,
    cb,
  };
}

// Get User Groups
export function getUserGroups(cb) {
  return {
    type: types.GET_USER_GROUPS,
    cb,
  };
}

export function getUserGroupsSuccess(payload) {
  return {
    type: types.GET_USER_GROUPS_SUCCESS,
    payload,
  };
}

export function modifyUserGroups(payload, cb) {
  return {
    type: types.MODIFY_USER_GROUPS,
    payload,
    cb,
  };
}

export function createUserGroups(payload, cb) {
  return {
    type: types.CREATE_USER_GROUPS,
    payload,
    cb,
  };
}

// Get Approvals
export function getApprovals(cb) {
  return {
    type: types.GET_APPROVAL,
    cb,
  };
}

export function modifyApprovals(payload, cb) {
  return {
    type: types.MODIFY_APPROVAL,
    payload,
    cb,
  };
}

export function createApprovals(payload, cb) {
  return {
    type: types.CREATE_APPROVAL,
    payload,
    cb,
  };
}

export function searchUserGroups(payload, cb) {
  return {
    type: types.SEARCH_USER_GROUPS,
    payload,
    cb,
  };
}
